<!-- ALTERACAO NOS VALORES DE ICMS DOS ITENS DA DI -->

<script>
import { SysVars } from '../main';
import { arr, calcDesconto } from '../shared/numbers'
import { getText, formatDate, formatValue } from '../shared/utils'

export default {
    props: {
        params: {}, //RECEBE 3 OBJETOS: DI, DIIT (itens) E DIAD (adicoes)
    },

    components: {

    },

    data () {
        return {
            //entidades
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao da nf apos a gravacao
        }
    },

    computed: {
        di: function () {
            return this.params.di
        },

        diad: function () {
            return this.params.diad
        },

        diit: function () {
            return this.params.diit
        },
    },

    filters: {
        format: function (value, decimals) {
            return formatValue(value, decimals)
        },
    },

    methods: {

        data (value) {
            return formatDate(value)
        },

        handleSalvar () {
            // for (let i = 0; i < this.diit.length; i++) {
            //     let lAdicao = {}
            //     for (let x = 0; x < this.diad.length; x++) {
            //         if (this.diad[x].nadicao == this.diit[i].nadicao) {
            //             lAdicao = this.diad[x]
            //         }
            //     }
            //     //atualiza as aliquotas da adicao no item
            //     this.diit[i].aicm = lAdicao.aicm
            //     this.diit[i].ricm = lAdicao.ricm
            //     this.diit[i].mva = lAdicao.mva
            //     this.diit[i].sticm = lAdicao.sticm
            //     this.diit[i].motdesicm = lAdicao.motdesicm
            // }
            this.$emit('save')
        },

        closeForm () {
            this.$emit('closeform')
        },

    },

    watch: {

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })
        this.$scrollTo(0)
    }

}

</script>

<template>
    <div>
        <div class="row mb-3">
            <div class="col-md-6 col-12">
                <h4 class="def-title"> Alterar Valor de ICMS nos Itens</h4>
            </div>
            <div class="col-md-6 col-12">
                <div class="float-right">
                    <v-button label="Retornar" title="" icon="fa-arrow-left" @click="closeForm"></v-button>
                    <v-button label="Salvar" title="" icon="fa-download" :nb-btdef="true" @click="handleSalvar"></v-button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-4" v-if="di.part && di.part.length">
                <v-label :metadata-field="metadata.di.codpart"></v-label><br>
                <span class="lbl"> {{ di.part[0].nome }} </span>
            </div>
            <div class="col-md-4 col-4">
                <v-label label="Número"></v-label><br>
                <span class="lbl">{{ di.numerodi }}</span>
            </div>
            <div class="col-md-4 col-4">
                <v-label label="Data"></v-label><br>
                <span class="lbl">{{ data(di.datadesemb) }}</span>
            </div>
        </div>

        <!-- ITENS E ALIQUOTAS DE ICMS -->
        <div>
            <label-title title="Itens Importados"></label-title><br>
            <div class="mainbox" v-for="(it, index) in diit" v-bind:key="index">
                <div v-if="it.stitemdi == '1'" class="mark-red"></div>
                <div v-if="it.stitemdi == '0'" class="mark-green"></div>
                <div class="box">
                    <div class="row">
                        <div class="col-md-2 col-3">
                            <v-label class="lbl-edit" :metadata-field="metadata.diit.nadicao"></v-label><br>
                            <span class="data-list">{{ it.nadicao }}</span>
                        </div>
                        <div class="col-md-8 col-6">
                            <v-label class="lbl-edit" :metadata-field="metadata.diit.descricaox"></v-label><br>
                            <span class="data-list" v-if="it.item && it.item.length>0">{{ it.item[0].descricao }}</span>
                            <!-- <v-label class="lbl-edit" :metadata-field="metadata.diit.descricaox"></v-label><br> -->
                            <label class="data-list">{{ it.descricaox }}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2 col-3">
                            <v-label class="lbl-edit" :metadata-field="metadata.diit.qt"></v-label><br>
                            <span class="data-list">{{ it.qt | format(4) }} ({{ it.unidadex }})</span>
                        </div>
                        <div class="col-md-2 col-3">
                            <v-label class="lbl-edit" :metadata-field="metadata.diit.vlr"></v-label><br>
                            <span class="data-list">{{ it.vlr | format(4) }}</span>
                        </div>
                        <div class="col-md-2 col-3">
                            <v-label class="lbl-edit" :metadata-field="metadata.diit.ricm"></v-label><br>
                            <span class="data-list">{{ it.ricm | format(2) }}</span>
                        </div>
                        <form-field v-model="it.bcicm" type="value" col="2" :metadata="metadata.diit.bcicm"></form-field>
                        <form-field v-model="it.vicm" type="value" col="2" :metadata="metadata.diit.vicm"></form-field>
                    </div>
                    <div class="row">
                        <form-field v-model="it.bcii" type="value" col="2" :metadata="metadata.diit.bcii"></form-field>
                        <form-field v-model="it.vii" type="value" col="2" :metadata="metadata.diit.vii"></form-field>
                        <form-field v-model="it.bcipi" type="value" col="2" :metadata="metadata.diit.bcipi"></form-field>
                        <form-field v-model="it.vipi" type="value" col="2" :metadata="metadata.diit.vipi"></form-field>
                    </div>
                    <div class="row">
                        <form-field v-model="it.bcpiscofins" type="value" col="2" :metadata="metadata.diit.bcpiscofins"></form-field>
                        <form-field v-model="it.vpis" type="value" col="2" :metadata="metadata.diit.vpis"></form-field>
                        <form-field v-model="it.vcofins" type="value" col="2" :metadata="metadata.diit.vcofins"></form-field>
                    </div>
                </div>
            </div>
            <div>
                <br>
                <div class="row">
                    <div class="col-md-12 col-12">
                        <div class="float-right">
                            <v-button label="Retornar" title="" icon="fa-arrow-left" @click="closeForm"></v-button>
                            <v-button label="Salvar" title="" icon="fa-download" :nb-btdef="true" @click="handleSalvar"></v-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- FIM ITENS E ALIQUOTAS DE ICMS -->

    </div>
</template>



// WEBPACK FOOTER //
// src/forms/nfimport-icms-form.vue